import styled from "styled-components"

export const LoginKey = styled.img(() => ({
    marginLeft: "3px",
    width: "6px",
    height: '16px'
}));
